import React from 'react';
import { Link } from '@/components/Link';
import styled from 'styled-components';
import { LinkProps } from 'next/link';
import { Image, ImageProps } from '../../../wag-react/next-components/image';
import { Typography } from '../../../wag-react/components/Typography';
import { Box, BoxProps } from '../../../wag-react/next-components/box';
export type GenericHealthArticleAdvertCardProps = Omit<BoxProps, 'background'> & {
  logo: {
    src: string;
    alt: string;
  };
  background: {
    src: string;
    type: 'corner' | 'full';
    color?: string;
  };
  subheading: string;
  content: string;
  button: {
    label: string;
    backgroundColor: string;
    textColor: string;
    href: string;
  };
  contentProps?: BoxProps;
  imageContainerProps?: BoxProps;
  imageProps?: ImageProps;
  hoverTextColor: string;
  hoverBackgroundColor: string;
};
export const GenericHealthArticleAdvertCard = ({
  logo,
  subheading,
  button,
  content,
  background,
  contentProps,
  imageContainerProps,
  imageProps,
  hoverTextColor,
  hoverBackgroundColor,
  ...rest
}: GenericHealthArticleAdvertCardProps) => <HoverLink href={button.href} hoverTextColor={hoverTextColor} hoverBackgroundColor={hoverBackgroundColor} data-sentry-element="HoverLink" data-sentry-component="GenericHealthArticleAdvertCard" data-sentry-source-file="Generic.tsx">
    <Box position="relative" display="flex" flexDirection="column" justifyContent="space-between" alignItems="flex-start" borderRadius="12px" overflow="hidden" aspectRatio={['none', 'none', '1']} minHeight={['300px', '300px', 'unset']} backgroundColor={background.color} maxHeight="400px" marginLeft="auto" marginRight="auto" width="100%" {...rest} data-sentry-element="Box" data-sentry-source-file="Generic.tsx">

      <Box mb="35px" zIndex={2} px="24px" pt="24px" {...contentProps} data-sentry-element="Box" data-sentry-source-file="Generic.tsx">
        <Image src={logo.src} alt={logo.alt} height="27px" maxWidth="100%" mb="10px" data-sentry-element="Image" data-sentry-source-file="Generic.tsx" />
        <Typography mb="0" color="white" fontSize="16px" lineHeight="22px" fontWeight="bold" mt="0" data-sentry-element="Typography" data-sentry-source-file="Generic.tsx">
          {subheading}
        </Typography>
        <Typography color="white" fontSize="14px" lineHeight="20px" data-sentry-element="Typography" data-sentry-source-file="Generic.tsx">
          {content}
        </Typography>
      </Box>
      <Box px="24px" pb="24px" zIndex={2} data-sentry-element="Box" data-sentry-source-file="Generic.tsx">
        <Box className="button" border="none" backgroundColor={button.backgroundColor} borderRadius="8px" py="12px" px="20px" cursor="pointer" data-sentry-element="Box" data-sentry-source-file="Generic.tsx">
          <Typography color={button.textColor} m="0" fontWeight="700" fontSize="16px" data-sentry-element="Typography" data-sentry-source-file="Generic.tsx">
            {button.label}
          </Typography>
        </Box>
      </Box>

      {background?.type === 'full' ? <Image position="absolute" top="0" left="0" width="100%" height="100%" src={background.src} style={{
      objectFit: 'cover',
      objectPosition: 'right bottom'
    }} backgroundPosition="bottom" zIndex={1} alt="background" {...imageProps} /> : <Box position="absolute" display="flex" top="0" left="0" width="100%" height="100%" justifyContent="flex-end" alignItems="flex-end" zIndex={1} {...imageContainerProps}>
          <Image width="50%" right="0" bottom="0" src={background.src} alt="background" {...imageProps} />
        </Box>}
    </Box>
  </HoverLink>;
export type HoverLinkProps = {
  children?: JSX.Element;
  href?: string;
  target?: string;
} & Omit<LinkProps, 'href' | 'target' | 'children'>;
const HoverLink = styled(({
  children,
  href,
  target,
  ...rest
}: HoverLinkProps) => <Link href={href} target={target} {...rest}>
    {children}
    {' '}
  </Link>)<{
  hoverTextColor: string;
  hoverBackgroundColor: string;
} & LinkProps>`
.button {
  transition: 0.3s all ease-out;
}
&:hover {
  .button {
    transition: 0.3s all ease-out;
    p {
      transition: 0.3s all ease-out;
      color: ${props => props.hoverTextColor} !important;
    }
    background-color: ${props => props.hoverBackgroundColor};
  }
}`;